/**
 * Thin wrapper used by every `/inspect/{fp}/exceptions/<slug>` route. Defers
 * to `ExceptionsHub` with the URL slug pre-selected in the left rail.
 */
import React from 'react'
import ExceptionsHub, {
  ExceptionAreaSlug,
} from '../../../../components/inspector/Exceptions/ExceptionsHub'

interface SharedExceptionsListProps {
  objectType: ExceptionAreaSlug
}

const SharedExceptionsList: React.FC<SharedExceptionsListProps> = ({ objectType }) => (
  <ExceptionsHub selectedSlug={objectType} />
)

export default SharedExceptionsList
